import { render, staticRenderFns } from "./connect.area.page.vue?vue&type=template&id=4363c5a8&scoped=true&"
import script from "./connect.area.page.vue?vue&type=script&lang=js&"
export * from "./connect.area.page.vue?vue&type=script&lang=js&"
import style0 from "./connect.area.page.vue?vue&type=style&index=0&id=4363c5a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4363c5a8",
  null
  
)

export default component.exports